export const BannerInfoIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
    <circle cx="9" cy="9" r="8" stroke="#00BA5C" strokeWidth="1.5"/>
    <path d="M9 8v5" stroke="#00BA5C" strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="9" cy="5.5" r="1" fill="#00BA5C"/>
  </svg>
);
